module.exports = __webpack_public_path__ + "img/stamp-golden-milestone-shovel.9cb58ec0.png";